import type {
  ParametersObservedTimeSeriesForLocationResult,
  ParametersTimeSeries,
} from "./generated/types";

export function isObservedTimeSeriesLoadFailure(
  result: ParametersObservedTimeSeriesForLocationResult | undefined,
): result is ParametersObservedTimeSeriesForLocationResult & { data: null } {
  return result != null && result.data === null;
}

export function hasObservedTimeSeriesData(
  result: ParametersObservedTimeSeriesForLocationResult | undefined,
): result is ParametersObservedTimeSeriesForLocationResult & {
  data: ParametersTimeSeries;
} {
  return result != null && result.data != null;
}
